export enum BrowserTheme {
    Light = 'light',
    Dark = 'dark',
}
